import { CARD_EVENTS } from './card/events';

export const WS_EVENTS = {
  ...CARD_EVENTS,
};
